"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _feedback = require("@/api/feedback");

var state = {
  user_name: '',
  cat_sex: ''
};
var mutations = {
  SET_USER_NAME: function SET_USER_NAME(state, user_name) {
    state.user_name = user_name;
  },
  SET_CAT_SEX: function SET_CAT_SEX(state, cat_sex) {
    state.cat_sex = cat_sex;
  }
};
var actions = {
  edit: function edit(_ref, catInfo) {
    var commit = _ref.commit;
    var user_name = catInfo.user_name,
        cat_sex = catInfo.cat_sex;
    return new Promise(function (resolve, reject) {
      (0, _feedback.edit)(catInfo).then(function (response) {
        var data = response.data;
        commit('SET_USER_NAME', user_name);
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};
var _default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};
exports.default = _default;